module.exports = __webpack_public_path__ + "static/media/imgs_500.b9edf98f.jpg";